import React from "react";
export default function AsistenciaMedica({ bgColor }) {
  return (
    <>
      <section className={`asistenciamedica ptb-100  ${bgColor ? "gray-light-bg" : ""}`} id="asistenciamedica">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-8">
              <div className="section-heading text-center mb-4">
                <h2>ASISTENCIA MÉDICA</h2>
                <p className="lead">Cobertura total para tu viaje</p>
              </div>
            </div>
          </div>

          <div
            className={`contact-us ptb-10`}
          >
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-12 col-sm-12 col-lg-5">
                  <div className="team-single-img">
                    <img
                      src="assets/img/sponsors/assistcardLogoCuadrado.jpg"
                      alt="member"
                      className="img-fluid rounded shadow-sm"
                    />
                  </div>
                </div>
                <div className="col-md-12 col-sm-12 col-lg-6">
                  <div className="team-single-text">
                    <div className="team-name mb-4">
                      <h4 className="mb-1">AssisTravel/Vittal</h4>
                    </div>
                    <div className="text-content mt-20">
                      <p>
                        Por ser uno de los pilares fundamentales del servicio,
                        la cobertura es de carácter total, desde la salida hasta
                        el regreso del grupo. Contamos con el respaldo de
                        empresas lideres a nivel mundial en servicio de
                        asistencia al viajero, las cuales nos brindan cobertura
                        total, ya sea en el destino turístico como así también
                        en los trayectos del viaje de ida y de vuelta, contando
                        para esto último con una extensa red de cobertura a lo
                        largo de todo el recorrido.
                      </p>
                      <div className="">
                        <div className="section-heading">
                          <h5>Nuestra Cobertura</h5>
                          <div className="section-heading-line-left"></div>
                        </div>
                        <ul className="list-unstyled">
                          <li className="py-2">
                            <div className="d-flex align-items-center">
                              <div>
                                <div className="badge badge-primary mr-3">
                                  <span className="ti-check"></span>
                                </div>
                              </div>
                              <div>
                                <p className="mb-0">
                                  Servicio ambulatorio de alta complejidad 24hs
                                </p>
                              </div>
                            </div>
                          </li>
                          <li className="py-2">
                            <div className="d-flex align-items-center">
                              <div>
                                <div className="badge badge-primary mr-3">
                                  <span className="ti-check"></span>
                                </div>
                              </div>
                              <div>
                                <p className="mb-0">
                                  Traslados Aereos para Pacientes y Familiares /
                                  Cirugias e Internación.
                                </p>
                              </div>
                            </div>
                          </li>
                          <li className="py-2">
                            <div className="d-flex align-items-center">
                              <div>
                                <div className="badge badge-primary mr-3">
                                  <span className="ti-check"></span>
                                </div>
                              </div>
                              <div>
                                <p className="mb-0">
                                  Radiografías / Yesos / Odontología
                                </p>
                              </div>
                            </div>
                          </li>
                          <li className="py-2">
                            <div className="d-flex align-items-center">
                              <div>
                                <div className="badge badge-primary mr-3">
                                  <span className="ti-check"></span>
                                </div>
                              </div>
                              <div>
                                <p className="mb-0">
                                  Medicamentos 100% , Ficha médica personal /
                                  Seguimiento individual.
                                </p>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
